import {
  Control,
  Controller,
  UseFormSetValue,
  useWatch,
} from 'react-hook-form';
import {
  CreateProductFormSchemaType,
  generateSubTitle,
  useGenerateDetailTitle,
} from '../common';
import { FormLabel } from '../form-label';
import i18n from 'i18n';
import LOCALS from 'commons/locals';
import { Select } from 'antd';
import { SelectOption } from 'types/base';
import { useCallback } from 'react';
import { useAppSelector } from 'store/hooks';
import { selectGlobalInfo } from 'store/slices/globalInfoSlice';

const ProductColor = ({
  control,
  setValue,
}: {
  control: Control<CreateProductFormSchemaType>;
  setValue: UseFormSetValue<CreateProductFormSchemaType>;
}) => {
  const { colorSelectOptions } = useAppSelector(selectGlobalInfo);
  const SelectFilter = useCallback(
    (input: string, option: SelectOption | undefined) =>
      (option?.label ?? '').toLowerCase().includes(input.toLowerCase()),
    []
  );

  const name = useWatch({
    control,
    name: 'name',
  });

  const { generateDetailTitle } = useGenerateDetailTitle(control);

  return (
    <div className="flex items-center gap-2">
      <FormLabel>{i18n.t(LOCALS.color)}:</FormLabel>
      <Controller
        name="color"
        control={control}
        render={({ field }) => (
          <Select
            {...field}
            className="w-full"
            mode="multiple"
            showSearch
            options={colorSelectOptions}
            filterOption={SelectFilter}
            placeholder={i18n.t(LOCALS.please_select)}
            onChange={(value) => {
              field.onChange(value);
              const subTitle = generateSubTitle(
                name,
                value,
                colorSelectOptions
              );
              setValue('subTitle', subTitle);

              const detailTitle = generateDetailTitle({
                color: value,
              });
              setValue('detailTitle', detailTitle);

              if (value && value.length > 1) {
                setValue('colors', 'multi-color');
              }

              if (value && value.length === 1) {
                const color = colorSelectOptions.find(
                  (d) => d.value === value[0]
                );
                if (color && (color.refProperty1 || color.refProperty2)) {
                  setValue('colors', color.refProperty1 || color.refProperty2);
                }
              }

              if (!value || value.length === 0) {
                setValue('colors', undefined);
              }
            }}
          />
        )}
      />
    </div>
  );
};

export default ProductColor;
